<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>产品管理</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>价格管理</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button class="qinang-button-margin" icon="user" @click="employeeSales">分配员工销售权限</a-button>
				<a-button class="qinang-button-margin" icon="desktop" @click="windowSales">分配窗口销售权限</a-button>
				<a-button icon="sync" @click="apiPriceQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="价格查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">价格编码：</div>
						<a-input v-model="query.priceCode" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiPriceQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						{{priceManageMain[0].facilitatorName}}
					</a-breadcrumb-item>
					<a-breadcrumb-item>
						{{priceManageMain[1].productName}}
					</a-breadcrumb-item>
				</a-breadcrumb>
				<a-tooltip placement="bottomRight">
					<template slot="title">
					  <span>返回上一级</span>
					</template>
					<a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
				</a-tooltip>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="priceId" :loading="tableLoading" :pagination="false">
	
				<span slot="priceCode" slot-scope="priceCode">
					<a-button type="link" @click="edit(priceCode)" >{{priceCode.priceCode}}</a-button>
				</span>
				<span slot="productId" slot-scope="productId">
					{{priceManageMain[1].productName}}
				</span>
				<span slot="businesstypeId" slot-scope="businesstypeId">
					{{businesstypeMap['ywlx'+businesstypeId].businesstypeName}}
				</span>
				<span slot="crowdtypeId" slot-scope="crowdtypeId">
					{{crowdtypeMap['rqzl'+crowdtypeId].crowdtypeName}}
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" >规则管理</a-button>
				</span>
				<span slot="listingPrice" slot-scope="listingPrice">
					{{listingPrice / 100}}
				</span>
				<span slot="salePrice" slot-scope="salePrice">
					{{salePrice / 100}}
				</span>
				<span slot="priceGroup" slot-scope="priceGroup">
					{{jgfzMap['jgfz'+priceGroup].valueA}}
				</span>
				<span slot="onlineSale" slot-scope="onlineSale">
					<span v-if="onlineSale == 2">否</span>
					<span v-if="onlineSale == 3">是</span>
				</span>
				<span slot="sceneSale" slot-scope="sceneSale">
					<span v-if="sceneSale == 2">否</span>
					<span v-if="sceneSale == 3">是</span>
				</span>
				
				<span slot="priceState" slot-scope="priceState">
					<span v-if="priceState == 2">禁用</span>
					<span v-if="priceState == 3">启用</span>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
	
					<a-form-model-item label="产品名称" >
						{{priceManageMain[1].productName}}
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格代码" has-feedback prop="priceCode">
							<a-input v-model="addForm.priceCode" placeholder="请输入价格代码" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：建议输入6位以内数字或字母组合的值，此值可用作售票软件快捷键)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="人群种类" has-feedback prop="crowdtypeId">
							<a-select v-model="addForm.crowdtypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in crowdtypeList" :key="index" :value="item.crowdtypeId">{{item.crowdtypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="业务类型" has-feedback prop="businesstypeId">
							<a-select v-model="addForm.businesstypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in businesstypeList" :key="index" :value="item.businesstypeId">{{item.businesstypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格开始日期" has-feedback prop="startDate">
							 <a-date-picker v-model="addForm.startDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格结束日期" has-feedback prop="endDate">
							 <a-date-picker v-model="addForm.endDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否实名制" has-feedback prop="isRealName">
							<a-radio-group name="isRealName" v-model="addForm.isRealName">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<a-form-model-item label="采集类型" has-feedback prop="collectionType">
						<a-radio-group name="collectionType" v-model="addForm.collectionType">
							<a-radio :value="2">不采集</a-radio>
							<a-radio :value="3">采集指纹</a-radio>
							<a-radio :value="4">采集人脸</a-radio>
						</a-radio-group>
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="挂牌价" has-feedback prop="listingPrice">
							<a-input v-model="addForm.listingPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="实际售价" has-feedback prop="salePrice">
							<a-input v-model="addForm.salePrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="结算价" has-feedback prop="settlementPrice">
							<a-input v-model="addForm.settlementPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格排序" has-feedback prop="priceSort">
							<a-input v-model="addForm.priceSort" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：请输入9位以内数字，排序为从大到小)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="库存设置" has-feedback prop="inventoryType">
							<a-select v-model="addForm.inventoryType">
								<a-select-option :value="2">不限制</a-select-option>
								<a-select-option :value="3">限制</a-select-option>
							</a-select>
						</a-form-model-item>
						<!-- <div class="qa-table-item-1-remarks-right" style=""></div> -->
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否网上销售" has-feedback prop="isRealName">
							<a-radio-group name="onlineSale" v-model="addForm.onlineSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否现场销售" has-feedback prop="isRealName">
							<a-radio-group name="sceneSale" v-model="addForm.sceneSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格分组" has-feedback prop="priceGroup">
							<a-select v-model="addForm.priceGroup">
								<a-select-option value="">请选择</a-select-option>
								<a-select-option v-for="(item,index) in jgfzList" :key="index" :value="item.sysparmName">{{item.valueA}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否启用" has-feedback prop="priceState">
							<a-radio-group name="priceState" v-model="addForm.priceState">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="语音提示" has-feedback prop="voicePrompt">
							<a-input v-model="addForm.voicePrompt" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：输入语音文件名称，用于闸机或手持机等检票设备播放语音提示)</div>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
						</a-form-model-item>
					</div>
					
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<a-form-model-item label="产品名称" >
						{{priceManageMain[1].productName}}
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格代码" has-feedback prop="priceCode">
							<a-input v-model="editForm.priceCode" placeholder="请输入价格代码" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：建议输入6位以内数字或字母组合的值，此值可用作售票软件快捷键)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="人群种类" has-feedback prop="crowdtypeId">
							<a-select v-model="editForm.crowdtypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in crowdtypeList" :key="index" :value="item.crowdtypeId">{{item.crowdtypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="业务类型" has-feedback prop="businesstypeId">
							<a-select v-model="editForm.businesstypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in businesstypeList" :key="index" :value="item.businesstypeId">{{item.businesstypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格开始日期" has-feedback prop="startDate">
							 <a-date-picker v-model="editForm.startDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格结束日期" has-feedback prop="endDate">
							 <a-date-picker v-model="editForm.endDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否实名制" has-feedback prop="isRealName">
							<a-radio-group name="isRealName" v-model="editForm.isRealName">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<a-form-model-item label="采集类型" has-feedback prop="collectionType">
						<a-radio-group name="collectionType" v-model="editForm.collectionType">
							<a-radio :value="2">不采集</a-radio>
							<a-radio :value="3">采集指纹</a-radio>
							<a-radio :value="4">采集人脸</a-radio>
						</a-radio-group>
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="挂牌价" has-feedback prop="listingPrice">
							<a-input v-model="editForm.listingPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="实际售价" has-feedback prop="salePrice">
							<a-input v-model="editForm.salePrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="结算价" has-feedback prop="settlementPrice">
							<a-input v-model="editForm.settlementPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格排序" has-feedback prop="priceSort">
							<a-input v-model="editForm.priceSort" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：请输入9位以内数字，排序为从大到小)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="库存设置" has-feedback prop="inventoryType">
							<a-select v-model="editForm.inventoryType">
								<a-select-option :value="2">不限制</a-select-option>
								<a-select-option :value="3">限制</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否网上销售" has-feedback prop="isRealName">
							<a-radio-group name="onlineSale" v-model="editForm.onlineSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否现场销售" has-feedback prop="isRealName">
							<a-radio-group name="sceneSale" v-model="editForm.sceneSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格分组" has-feedback prop="priceGroup">
							<a-select v-model="editForm.priceGroup">
								<a-select-option value="">请选择</a-select-option>
								<a-select-option v-for="(item,index) in jgfzList" :key="index" :value="item.sysparmName">{{item.valueA}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否启用" has-feedback prop="priceState">
							<a-radio-group name="priceState" v-model="editForm.priceState">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="语音提示" has-feedback prop="voicePrompt">
							<a-input v-model="editForm.voicePrompt" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：输入语音文件名称，用于闸机或手持机等检票设备播放语音提示)</div>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
					
				</a-form-model>
			</div>
			
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				priceManageMain: JSON.parse(window.sessionStorage.getItem('priceManageMain')),
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				jgfzList: {},
				jgfzMap: [],
				crowdtypeList: {},
				crowdtypeMap: [],
				businesstypeList: {},
				businesstypeMap: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					productId: (JSON.parse(window.sessionStorage.getItem('priceManageMain')))[1].productId,
					priceCode: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'priceId', key:'priceId', align:'center'},
					{ title:'价格编码', key:'priceCode', align:'center', scopedSlots:{customRender:'priceCode'}},
					{ title:'产品名称', key:'productId', align:'center', scopedSlots:{customRender:'productId'}},
					{ title:'业务', key:'businesstypeId', dataIndex:'businesstypeId', align:'center', scopedSlots:{customRender:'businesstypeId'}},
					{ title:'人群种类', key:'crowdtypeId', dataIndex:'crowdtypeId',align:'center', scopedSlots:{customRender:'crowdtypeId'}},
					{ title:'操作', key:'tableAction', align:'center', scopedSlots:{customRender:'tableAction'}},
					{ title:'价格开始日期', dataIndex:'startDate', key:'startDate', align:'center'},
					{ title:'价格结束日期', dataIndex:'endDate', key:'endDate', align:'center'},
					{ title:'挂牌价', dataIndex:'listingPrice', key:'listingPrice', align:'center', scopedSlots:{customRender:'listingPrice'}},
					{ title:'实际售价', dataIndex:'salePrice', key:'salePrice', align:'center', scopedSlots:{customRender:'salePrice'}},
					{ title:'价格分组', key:'priceGroup', dataIndex:'priceGroup',align:'center', scopedSlots:{customRender:'priceGroup'}},
					{ title:'网上销售', dataIndex:'onlineSale', key:'onlineSale', align:'center', scopedSlots:{customRender:'onlineSale'}},
					{ title:'现场销售', dataIndex:'sceneSale', key:'sceneSale', align:'center', scopedSlots:{customRender:'sceneSale'}},
					{ title:'排序', dataIndex:'priceSort', key:'priceSort', align:'center' },
					
					{ title:'状态', dataIndex:'priceState', key:'priceState', align:'center', scopedSlots:{customRender:'priceState'}},
					
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: 0,
					productId: 0,
					priceCode: '',
					crowdtypeId: 0,
					businesstypeId: 0,
					startDate: moment(),
					endDate: moment(),
					isRealName: 2,
					collectionType: 2,
					listingPrice: 0,
					salePrice: 0,
					settlementPrice: 0,
					priceSort: 0,
					inventoryType: 2,
					onlineSale: 2,
					sceneSale: 3,
					priceGroup: '',
					priceState: 3,
					voicePrompt: '',
					remarks: '',
					
				},
				addRules: {
					priceCode: [{ required: true, message: '产品代码不能为空', trigger: 'blur' }],
					crowdtypeId: [{ required: true, type: 'number', min: 1, message: '请选择', trigger: 'blur' }],
					businesstypeId: [{ required: true, type: 'number', min: 1, message: '请选择', trigger: 'blur' }],
					startDate: [{ required: true, message: '请选择', trigger: 'blur' }],
					endDate: [{ required: true, message: '请选择', trigger: 'blur' }],
					isRealName: [{ required: true, message: '请选择', trigger: 'blur' }],
					collectionType: [{ required: true, message: '请选择', trigger: 'blur' }],
					listingPrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					salePrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					settlementPrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					onlineSale: [{ required: true, message: '请选择', trigger: 'blur' }],
					sceneSale: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceGroup: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					productId: '',
					facilitatorId: '',
					productName: '',
					productCode: '',
					productClass: 2,
					checkType: 2,
					useType: 2,
					outType: 2,
					mediumClass: 2,
					productState: 2,
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//返回
			backMainNavigation(){
				this.$router.push('/BasicTicket');
			},
			//获取价格分组
			async apiSysparmListByName() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmListByName, {sysparmName: 'JGFZ'});
				if (res.code == 200) {
					this.jgfzList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.jgfzMap['jgfz'+res.data[i].sysparmName] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取人群种类
			async apiCrowdtypeList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeList);
				if (res.code == 200) {
					this.crowdtypeList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.crowdtypeMap['rqzl'+res.data[i].crowdtypeId] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取业务类型
			async apiBusinesstypeList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBusinesstypeList);
				if (res.code == 200) {
					this.businesstypeList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.businesstypeMap['ywlx'+res.data[i].businesstypeId] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//--------------表格开始-搜索
			async apiPriceQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPriceQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPriceQueryList()
			},
			tableAdd() {
				this.addVisible = true
			},
			async apiPriceAdd() {
				let data = JSON.parse(JSON.stringify(this.addForm))
				data.facilitatorId = this.priceManageMain[0].facilitatorId
				data.productId = this.priceManageMain[1].productId
				data.listingPrice = this.addForm.listingPrice * 100
				data.salePrice = this.addForm.salePrice * 100
				data.settlementPrice = this.addForm.settlementPrice * 100
				data.startDate = this.addForm.startDate.format('YYYY-MM-DD')
				data.endDate = this.addForm.endDate.format('YYYY-MM-DD')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceAdd, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiPriceQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPriceAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				items.productId = this.priceManageMain[1].productId
				items.listingPrice = item.listingPrice / 100
				items.salePrice = item.salePrice / 100
				items.settlementPrice = item.settlementPrice / 100
				items.startDate = this.moment(item.startDate)
				items.endDate = this.moment(item.endDate)
				this.editForm = items
				this.editVisible = true
			},
			async apiPriceEdit() {
				let data = JSON.parse(JSON.stringify(this.editForm))
				data.facilitatorId = this.priceManageMain[0].facilitatorId
				data.listingPrice = this.editForm.listingPrice * 100
				data.salePrice = this.editForm.salePrice * 100
				data.settlementPrice = this.editForm.settlementPrice * 100
				data.startDate = this.editForm.startDate.format('YYYY-MM-DD')
				data.endDate = this.editForm.endDate.format('YYYY-MM-DD')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceEdit, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiPriceQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPriceEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.productId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.departmentName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPriceDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPriceDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceDel, {priceId: this.tableSelectedRows.priceId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.productId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			//-----------------员工销售权限--------
			employeeSales(){
				
			},
			//-----------------窗口销售权限--------
			windowSales(){
				
			},
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiSysparmListByName()
			this.apiCrowdtypeList()
			this.apiBusinesstypeList()
			setTimeout(()=>this.apiPriceQueryList(),500)
			
		}
	};
</script>

<style scoped>

	
</style>
